import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import AppliedOffersContainer from 'src/containers/AppliedOffersContainer';
import SavedOffersContainer from 'src/containers/SavedOffersContainer';
import LastSeenOffersContainer from 'src/containers/LastSeenOffersContainer';

import { APPLIED, SAVED } from 'src/redux/actions/tabs';


class OffersContainer extends PureComponent {
  render() {
    const { activeTab } = this.props;

    if (activeTab === APPLIED) {
      return <AppliedOffersContainer />;
    }
    if (activeTab === SAVED) {
      return <SavedOffersContainer />;
    }

    return <LastSeenOffersContainer />;
  }
}

OffersContainer.propTypes = {
  activeTab: PropTypes.string.isRequired
};

const mapStateToProperties = state => ({
  activeTab: state.tabsReducer.activeTab
});

export default connect(mapStateToProperties)(OffersContainer);
